import { useContext, useEffect, useState } from 'react'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { getData } from 'src/consumer/services/profileService'
import { LoadingSpinner } from '../Loaders'
import { bookedPageViewTypes } from './my-live-sessions-utils'
import MyLiveSessionPageToRender from './MyLiveSessionPageToRender'

export default function MyLiveSessionsWrapper({
  pageViewType = bookedPageViewTypes.booked_sessions,
}) {
  const { setupData, setupLoading } = useContext(SetupContext)
  const { profileData } = useContext(ProfileContext)
  const [oneOnOneMentorsData, setOneOnOneMentorsData] = useState()

  useEffect(() => {
    ;(async () => {
      const response = await getData('/api/external/mentor/1on1/list')
      if (response?.status === 200) {
        setOneOnOneMentorsData(response?.data)
      }
    })()
  }, [])

  if (profileData && setupData && oneOnOneMentorsData) {
    return (
      <MyLiveSessionPageToRender
        pageViewType={pageViewType}
        propSetupData={setupData}
        propUserProfileData={profileData}
        propOneOnOneMentorsData={oneOnOneMentorsData}
      />
    )
  } else {
    return <LoadingSpinner bgColor="#f8f8f8" dark />
  }
}
